import React from 'react'
import { ReactComponent as LogoWhite } from '../../images/logo_vertical.svg'

const Privacy = (): JSX.Element => {
  return (
    <div>
      <div
        className={
          'relative flex bg-blue-primary justify-between items-center sm:px-10 py-10'
        }>
        <LogoWhite className={'h-32'} />
      </div>
      <div className={'max-w-7xl mx-auto p-4'}>
        <div className="entry-content">
          <h2 className={'font-bold text-2xl my-8'}>Privacy at LinkOne</h2>
          <p>
            LinkOne (“<u>LinkOne</u>” or “<u>we</u>”) is committed to respecting your
            online privacy and recognizes your need for appropriate protection and
            management of any personally identifiable information (“
            <u>Personal Information</u>”) you share with us. LinkOne has established this
            Privacy Policy to let you know what information we may collect from you on the
            publicly available portion of link1data.com (the “<u>Site</u>”) and how we may
            use and share that information. Please take a moment to review the terms of
            our Privacy Policy. By using the Site, you agree to accept the terms of our
            Privacy Policy. If you do not agree to the terms of this Privacy Policy,
            please do not use the Site. This Privacy Policy applies only to information
            that we collect on the Site and does not apply to information which we may
            collect by other means or through other websites. Also, if you are interested
            in seeing a description of our privacy practices with respect to our
            advertising services, please click here to see our Notice of Marketing
            Practices.
          </p>
          <h3 className={'font-bold text-xl my-4'}>Information We May Collect</h3>
          <p>
            Personal Information means any information that may be used to identify an
            individual, including, but not limited to, a first and last name, a home,
            business, or other physical address, a phone number, internet protocol (IP)
            addresses, and an e-mail address. In general, we only collect Personal
            Information from our Site users in connection with inquiries about our
            services through the “Contact” page or registering an account with us. For
            users who register for an account with LinkOne, we also collect information
            related to the company you represent and information and security questions to
            authenticate your account. Of course, if you send us an e-mail in connection
            with an inquiry about a job listed on the “Careers” page, we may also store
            the Personal Information provided in connection with that inquiry.
          </p>
          <p>
            For a better experience, and in order to provide our Service, we may require
            you to provide us, either directly or indirectly, with certain personally
            identifiable information, including but not limited to user name, and Oauth2
            credentials. The information that we request will be retained by us and used
            as described in this privacy policy.
          </p>
          <div className={'py-4'}>
            <b>Registration and authentication </b>
            <p className={'py-4'}>
              By registering or authenticating, Users allow this Application to identify
              them and give them access to dedicated services. Depending on what is
              described below, third parties may provide registration and authentication
              services. In this case, this Application will be able to access some Data,
              stored by these third party services, for registration or identification
              purposes.
            </p>
            <div>
              <h2><b>Google OAuth (Google Inc.)</b></h2>
              <p>
                This application uses Google OAuth API Services to allow users to link their Google Ads and
                Google Analytics accounts. In compliance with Google’s OAuth API Services User Data Policy, the application will:
              </p>

              <ul className="list-disc list-inside py-2 pl-4">
                <li>Request and securely store an OAuth token.</li>
                <li>Use the token only for authorized API calls to Google Ads and Google Analytics.</li>
                <li>Ensure that retrieved data is not shared with third parties and is used solely within the application.</li>
              </ul>
              <p>
                For details on Google's data handling, see the 
                <a className="text-blue-500" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                &nbsp;Google Privacy Policy
                </a>.
              </p>
              <p>Place of processing: US</p>
            </div>
            <div>
              <h2><b>Google Ads API Service (Google Inc.)</b></h2>
              <p>
                This application accesses the Google Ads API once a user links their Google Ads account.
              </p>
              <h3>Usage:</h3>
              <ul className="list-disc list-inside py-2 pl-4">
                <li>Manage account entities (e.g., campaigns, ads, keywords, audiences).</li>
                <li>Retrieve performance data (e.g., impressions, clicks, conversions).</li>
              </ul>
              <h3>Data Storage & Access:</h3>
              <p>
                Stored data is accessible only to authorized users (e.g., the account owner, authorized agency members,
                account managers). It will not be shared with third parties. Users can revoke access anytime via the application or 
                <a className="text-blue-500" href="https://myaccount.google.com/permissions" target="_blank" rel="noreferrer">
                  &nbsp;Google’s Security Settings
                </a>.
              </p>
              <p>
                For more information, see the
                <a className="text-blue-500" href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer">
                &nbsp;Google Ads Privacy Policy
                </a>.
              </p>
              <p>Place of processing: US</p>
            </div>
            <div>
              <h2><b>Google Analytics API Service (Google Inc.)</b></h2>
              <p>
                This application accesses the Google Analytics API after a user connects their account.
              </p>
              <h3>Usage:</h3>
              <ul>
                <li>Retrieve website traffic, audience insights, and engagement metrics.</li>
                <li>Generate custom reports and dashboards.</li>
              </ul>
              <h3>Data Storage & Access:</h3>
              <p>
                Stored data is accessible only to authorized users (e.g., account owners, agency members, account managers).
                It will not be shared with third parties. Users can revoke access anytime via
                <a className="text-blue-500" href="https://myaccount.google.com/permissions" target="_blank" rel="noreferrer">
                  &nbsp;Google’s Security Settings
                </a>.
              </p>
              <p>
                For more information, see the
                <a className="text-blue-500" href="https://support.google.com/analytics/answer/6004245?hl=en" target="_blank" rel="noreferrer">
                &nbsp;Google Analytics Privacy Policy
                </a>.
              </p>
              <p>Place of processing: US</p>
            </div>
            <div>
              <h2>Automated Data Synchronization</h2>
              <p>
                Once linked, the application may:
              </p>
              <ul className="list-disc list-inside py-2 pl-4">
                <li>Perform user-initiated actions (e.g., retrieving reports, updating campaigns).</li>
                <li>Sync data automatically (e.g., daily updates for accuracy).</li>
              </ul>
              <p>
                Users can disable syncing anytime by revoking OAuth access via
                <a className="text-blue-500" href="https://myaccount.google.com/permissions" target="_blank" rel="noreferrer">
                &nbsp;Google’s Security Settings
                </a>.
              </p>
            </div>
            <div>
              <h2><b>Data Retention & Security</b></h2>
              <ul className="list-disc list-inside py-2 pl-4">
                <li>OAuth tokens and data are stored only while the user’s account is active.</li>
                <li>If an account is disconnected or inactive for 90 days, data is automatically deleted.</li>
                <li>Users can request deletion anytime via <a href="mailto:support@link1data.com">support@link1data.com</a> (processed within 30 days).</li>
              </ul>
            </div>
            <div>
              <h2><b>Security & Compliance</b></h2>
              <p>
                We implement industry-standard security measures, including:
              </p>
              <ul className="list-disc list-inside py-2 pl-4">
                <li>Encryption of stored OAuth tokens and data.</li>
                <li>Access controls to prevent unauthorized access.</li>
                <li>Compliance with Google’s OAuth API Services User Data Policy, including
                  Limited Use restrictions (<a className="text-blue-500" href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noreferrer">Learn More</a>).
                </li>
              </ul>
              <p>
                For Google’s data policies, refer to the
                <a className="text-blue-500" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                &nbsp;Google Privacy Policy
                </a>.
              </p>
            </div>
          </div>
          <b>Facebook Custom Audience (Facebook, Inc.)</b>
          <div>
            <p>
              Facebook Custom Audience is a remarketing and behavioral targeting service
              provided by Facebook, Inc. that connects the activity of this Application
              with the Facebook advertising network.
            </p>
            <p>
              Personal Data collected: various types of data as specified in the privacy
              policy of the service
            </p>
            <p>
              Place of processing: US –{' '}
              <a
                className={'text-blue-500'}
                href={'https://www.facebook.com/about/privacy/'}
                target={'_blank'}
                rel={'noreferrer'}>
                Privacy Policy.
              </a>
            </p>
          </div>
          <h3 className={'font-bold text-xl my-4'}>How We May Use Your Information</h3>
          <p>
            This site is being monitored by one or more third-party monitoring
            software(s), and may capture information about your visit that will help us
            improve the quality of our service.. If you provide us with Personal
            Information, we may retain and use that information for several purposes,
            including facilitating your inquiry or request. For example, we may use your
            Personal Information in order to respond to your questions or requests for
            information about LinkOne. We may also use Personal Information to ensure
            compliance with our policies and applicable law. We reserve the right to send
            you certain communications relating to the Site or the services provided by
            LinkOne, such as service announcements, e-mails related to your account, or
            similar administrative or transactional messages, without offering you the
            opportunity to opt-out of receiving them.
          </p>
          <h3 className={'font-bold text-xl my-4'}>
            With Whom We May Share Your Information
          </h3>
          <p>
            We may sometimes use other businesses to perform certain services for us, such
            as maintaining the Site and our e-mail services and processing inquiries. We
            may provide Personal Information to those businesses when that information is
            necessary for them to complete a requested transaction or otherwise perform
            their duties. LinkOne will take reasonable steps to ensure that these third-
            party service providers are obligated to protect Personal Information on
            LinkOne’s behalf. LinkOne will not sell or share your Personal Information
            with any unaffiliated third parties for marketing purposes. In the event that
            LinkOne or all of its assets are acquired, customer information would be one
            of the transferred assets.
          </p>
          <p>
            We reserve the right to disclose visitor information in special cases when we
            have reason to believe that disclosing this information is necessary to
            identify, contact, or bring legal action against someone who may be causing
            injury to or interference with (either intentionally or unintentionally) our
            rights or property, other visitors, or anyone else that could be harmed by
            such activities. We also reserve the right to disclose visitor information
            when we believe in good faith that the law requires it.
          </p>
          <p className={'py-2'}>
            <i>Aggregate Information</i>
            <br /> From time to time, we may collect general, non-personal, statistical
            information about the use of the Site, such as how many visitors visit a
            specific page on the Site, how long they stay on that page and which
            hyperlinks, if any, they “click” on. We collect this information through the
            use of “cookies” and other tracking technologies, which are discussed in
            greater detail below. We collect this information in order to determine which
            areas of the Site are most popular and to enhance the Site for visitors. We
            may group this information into aggregate visitor data in order to describe
            the use of the Site to our existing or potential business partners, sponsors,
            advertisers, or other third parties, or in response to a government request.
            However, please be assured that this aggregate data will in no way personally
            identify you or any other visitors to the Site.
          </p>
          <p className={'py-2'}>
            <i>Cookies and Other Tracking Technologies</i>
            <br /> Some of our web pages utilize “cookies” and other tracking
            technologies, such as pixel gifs. A cookie is a small text file that a website
            transfers to an individual’s hard drive for record-keeping purposes. For
            example, we may use cookies to collect information about website activity. You
            may set most browsers to notify you if you receive a cookie, or you may choose
            to block cookies with your browser. However, please be aware that some
            features of the Site may not function properly or may be slower if you refuse
            cookies. We do not link the information we store in cookies to any Personal
            Information you submit while on the Site. A pixel gif (also known as web bugs
            or web beacons) are small, invisible graphic images that may be used by the
            Site or in emails relating to the Site to collect certain information and
            monitor user activity on the Site and may be combined with IP addresses or
            other information that we have gathered with respect to your use of our Site.
          </p>
          <p className={'py-2'}>
            Tracking technologies may record information such as Internet domain and host
            names; IP addresses; browser software and operating system types; clickstream
            patterns; and dates and times that our Site is accessed. It is not our
            practice to link the information we record using tracking technologies to any
            Personal Information you submit while on the Site. However, we reserve the
            right to use IP addresses and other tracking technologies to identify a
            visitor only when we feel it is necessary to enforce compliance with the
            Site’s policies, to protect the Site, our customers, or others, or when we
            believe in good faith that the law requires it.
          </p>
          <p className={'py-2'}>
            <i>Links to Other Sites; Public Venues</i>
            <br /> Please be aware that when you are on the Site, you could be directed to
            other sites that are beyond our control via hyperlinks. These other websites
            may send their own cookies to visitors, collect data, or solicit Personal
            Information. The privacy policies of these other sites may be significantly
            different from this Privacy Policy. We are not responsible for the privacy
            practices of these other sites and cannot guarantee the security of any of
            your Personal Information collected there.
          </p>
          <p className={'py-2'}>
            <i>Security</i>
            <br /> The security of your Personal Information is important to us. We take
            appropriate security measures to protect against unauthorized access to or
            unauthorized alteration, disclosure or destruction of data. These include
            internal reviews of our data collection, storage and processing practices and
            security measures, as well as physical security measures to guard against
            unauthorized access to systems where we store personal data. We restrict
            access to personal information to LinkOne employees,
            <br /> contractors and agents who need to know that information in order to
            operate, develop or improve our services. These individuals are bound by
            confidentiality obligations and may be subject to discipline, including
            termination and criminal prosecution, if they fail to meet these obligations.
          </p>
          <h3 className={'font-bold text-xl my-4'}>Children’s Privacy</h3>
          <p className={'py-2'}>
            This Site is not intended for use by children under 13. We do not knowingly
            collect Personal Information from anyone under 13 years of age. If we become
            aware that we have unknowingly collected Personal Information from a child
            under the age of 13, we will make commercially reasonable efforts to delete
            such information from our database.
          </p>
          <h3>Changes to Our Privacy Policy</h3>
          <p>
            The terms of this Privacy Policy may change from time to time. We will notify
            you of any material changes to this Privacy Policy by posting a notice on the
            homepage of the Site for a reasonable period of time after such changes are
            made that this Privacy Policy has been updated and by changing the “Last
            Modified” date at the bottom of this Privacy Policy. We encourage you to check
            this page periodically for any changes. Your continued use of the Site
            following the posting of changes to these terms will mean you accept those
            changes.
          </p>
          <h3 className={'font-bold text-xl my-4'}>Governing Law</h3>
          <p>
            LinkOne makes no representation that this Privacy Policy and such practices
            comply with the laws of any other country. Visitors who use the Site and
            reside outside the United States do so on their own initiative and are
            responsible for compliance with local laws, if and to the extent local laws
            are applicable. If you reside outside of the United States, by using our Site,
            you consent to the transfer and use of your information outside your country.
          </p>
          <h3 className={'font-bold text-xl my-4'}>Contacting Us</h3>
          <p>
            If you have any comments or questions regarding our Privacy Policy, please
            contact us at{' '}
            <a className={'text-blue-500'} href="mailto:info@link1data.com">
              info@link1data.com
            </a>
            , or at our contact information below.
          </p>
          <p>
            LinkOne
            <br /> 1300 1st St
            <br /> Suite 368
            <br /> Napa, CA 94559
            <br /> 415-300-0099
          </p>
          <p className={'pt-8'}>Last Modified: June 14, 2019</p>
        </div>
      </div>
    </div>
  )
}

export default Privacy
